/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientInstructionsModel } from '../../models/patient-instructions-model';

export interface GetPatientInstructions$Params {
  patientID?: number;
}

export function GetPatientInstructions(http: HttpClient, rootUrl: string, params?: GetPatientInstructions$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientInstructionsModel>> {
  const rb = new RequestBuilder(rootUrl, GetPatientInstructions.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientInstructionsModel>;
    })
  );
}

GetPatientInstructions.PATH = '/api/Supervisor/GetPatientInstructions';
